import { AuthLayout } from "@/components/layouts";
import { AuthCard } from "@/components/ui/AuthCard";
import { RunAsSupportCodeForm } from "@/features/accessRequests/RunAsSupportCodeForm";

const HEADLINE = {
  lead: "Act as",
  highlight: "a customer",
  description: "Paste the support code a customer sent you to see their account as they do.",
};

/** Standalone entry point kept for bookmarks; the same form lives on the Access Requests page. */
export const RunAsView = () => (
  <AuthLayout title="Run as a customer" headline={HEADLINE}>
    <AuthCard>
      <RunAsSupportCodeForm />
    </AuthCard>
  </AuthLayout>
);
